import { HttpContextToken } from '@angular/common/http';

export const REQUEST_META_DATA = {
  ALL: new HttpContextToken(() => false),
  PROGRESS: new HttpContextToken(() => false),
  FEEDBACK: new HttpContextToken(() => false),
  HEADERS: new HttpContextToken(() => false),
  URL: new HttpContextToken(() => false),
  REQUEST: new HttpContextToken(() => false),
  RESPONSE: new HttpContextToken(() => false),
  AUTHENTICATION: new HttpContextToken(() => false),
  HIDE_PROGRESS: new HttpContextToken(() => false),
  IS_UPLOAD: new HttpContextToken(() => false),
  SKIP_CONTENT_TYPE: new HttpContextToken(() => false),
  FORCE_INTERNAL: new HttpContextToken(() => false),
};
